module.exports = __webpack_public_path__ + "img/cov-study.2a3dd65c.jpg";